export default{
	"Header":require("./Header").default,
	"Tip":require("./Tip").default
}
